<div class="avatar-container position-relative">
    <div class="d-flex justify-content-center align-items-center avatar avatar-background">
        <!-- Display initials -->
        @if (initials) {
            <div class="position-absolute top-50 start-50 translate-middle text-white fw-bold font-monospace">{{ initials }}</div>
        } @else {
            <!-- Display generic user icon -->
            <fa-icon [icon]="userIcon"
                     class="position-absolute top-50 start-50 translate-middle text-white"/>
        }
    </div>

    <!-- Notifications Badge -->
    @if (hasNotifications) {
        <span
            class="position-absolute top-0 end-0 p-1 rounded-circle bg-danger">
        <span class="visually-hidden">New release notes</span>
    </span>
    }
</div>
